import React from 'react';

function WhyNeedSeoSection() {
  const handleQuoteClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="why-need-seo-section">
      <div className="container why-need-seo-container">
        {/* Left Column: Title, Content & Button */}
        <div className="why-need-seo-left">
          <h2 className="why-need-seo-title">
            Why Does Your Business Need <span className="why-need-seo-red-title">Professional SEO Services</span> To Grow Organically?
          </h2>

          <p className="why-need-seo-desc">
            SEO stands for Search Engine Optimization. It is the best way to increase the organic traffic of a website. SEO is a broad area with numerous strategies to improve a website’s organic position in search engine results. The strategies include on-page, off-page, and technical SEO. All the activities aim to achieve higher rankings for your products and services. <a href="/" className="seo-red-link">Experts Communication</a> offers SEO services in Pakistan to increase your website’s organic traffic and search engine rankings. Our team employs best practices such as on-page, off-page, and technical optimization, strategic keyword research, compelling content creation, and performance monitoring to make your site more visible on SERPs.
          </p>

          <button className="btn-seo-primary" onClick={handleQuoteClick}>
            Get Free Quote!
          </button>
        </div>

        {/* Right Column: Image Showcase */}
        <div className="why-need-seo-right">
          <div className="why-need-seo-img-wrapper">
            <img
              src="/assets/images/seo-services/seo-img2.jpg"
              alt="Why Does Your Business Need Professional SEO Services To Grow Organically"
              className="why-need-seo-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyNeedSeoSection;
